import {useState} from 'react';
import PropTypes from 'prop-types';
import {query} from 'api';
import {Container, ProfileLink, ConditionsForm, Option, InfoRow, Link, Button, PushHelp} from './styles';
import {MainTitleDark} from 'ui';

import {connect} from 'react-redux';
import {getNotificationsEnabledSelector, setNotificationsEnabled} from 'api/notifications';
import {deleteToken} from 'api/auth';
import {createStructuredSelector} from 'reselect';
import {isPushBlocked, isPushOptedIn, setPushOptIn} from 'lib/onesignal';

// Règlement de 2019, affiché tant que l'API ne fournit pas le document en vigueur.
const RULES_FALLBACK_URL =
  'https://maison.cartedor.fr/mco-content/uploads/2019/12/modalites-club-mcdo-181219.pdf';

const Profile = ({data, notificationsEnabled, setNotificationsEnabled, deleteToken}) => {
  const [pushBlocked, setPushBlocked] = useState(false);
  const handleTogglePush = async () => {
    const next = !notificationsEnabled;
    try {
      await setPushOptIn(next);
    } catch (e) {
      console.warn('OneSignal toggle failed', e);
    }
    // L'interrupteur reflète l'abonnement réel : une autorisation refusée le laisse éteint.
    setNotificationsEnabled(isPushOptedIn());
    setPushBlocked(next && isPushBlocked());
  };
  if (!data) return null;
  return (
    <Container>
      <MainTitleDark style={{paddingTop: 30, marginBottom: 25}}>Mes informations</MainTitleDark>

      <div style={{width: '100%', marginBottom: 25}}>
        <InfoRow label="Établissement" value={data.establishment} />
        <InfoRow label="Nom" value={data.last_name} />
        <InfoRow label="Prénom" value={data.first_name} />
        <InfoRow label="Adresse" value={data.address} />
        <InfoRow label="Code postal" value={data.postal_code} />
        <InfoRow label="Ville" value={data.city} />
        <InfoRow label="Email" value={data.email} />

        <div style={{marginTop: 24, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <ProfileLink href="https://maison.cartedor.fr/mon-compte/" target="_blank">
            Modifier mon email
          </ProfileLink>
          <ProfileLink href="https://maison.cartedor.fr/mon-compte/" target="_blank">
            Modifier mon mot de passe
          </ProfileLink>
        </div>
      </div>

      <ConditionsForm>
        <Option
          label="Je souhaite recevoir les emails et courriers promotionnels de Club Maison Carte d’Or"
          name="emails"
          id="emails"
          value={data.emails}
          readOnly
        />
        <Option
          label="J’accepte de recevoir les notifications de l’application du Club Maison Carte d’Or"
          name="notifications"
          id="notifications"
          value={notificationsEnabled}
          onChange={handleTogglePush}
        />
        {pushBlocked && (
          <PushHelp role="status">
            Les notifications sont bloquées sur ce téléphone. Pour les réautoriser, ouvrez les réglages
            du téléphone, puis Notifications, choisissez l’application «&nbsp;Le Club&nbsp;» et autorisez
            les notifications.
          </PushHelp>
        )}

        <Link href={data.rules_url || RULES_FALLBACK_URL} target="_blank" rel="noopener">
          Voir les conditions d’utilisation du Club
        </Link>
        <Button onClick={deleteToken} to="/">
          Déconnexion
        </Button>
      </ConditionsForm>
    </Container>
  );
};

Profile.propTypes = {
  data: PropTypes.object.isRequired,
  notificationsEnabled: PropTypes.bool.isRequired,
  setNotificationsEnabled: PropTypes.func.isRequired,
  deleteToken: PropTypes.func.isRequired,
};

export default Profile
  |> connect(
    createStructuredSelector({
      notificationsEnabled: getNotificationsEnabledSelector,
    }),
    {setNotificationsEnabled, deleteToken},
  )
  |> query('getProfile', {loadingFullWidth: true});
